import { DateTime } from 'luxon';

interface IDashboardMetadata {
	creationDate: string;
	expirationDate: string;
	timezone: string;
}

export const getFormattedMetadata = (metadata: IDashboardMetadata): string | undefined => {
	const { creationDate, expirationDate, timezone } = metadata;

	if (creationDate && expirationDate) {
		const formattedCreationDate = DateTime.fromISO(creationDate)
			.setZone(timezone)
			.toFormat('dd/MM/yyyy \'at\' HH:mm z');

		const { days: daysToExpire } = DateTime.local().diff(
			DateTime.fromISO(expirationDate).setZone(timezone),
			['days']
		);

		const formattedExpirationLabel = `Expires in ${Math.floor(Math.abs(daysToExpire))} days`;

		return `Report generated on ${formattedCreationDate} | ${formattedExpirationLabel}`;
	}
};
